import React from "react";
import { Link } from "react-router-dom";
import MatchmakingSection from "./MatchmakingSection";

// Standalone /matchmaking page so the home page stays focused on the hero.
export function MatchmakingPage({ onToast, onRequireAuth, onOpenLeague }) {
  return (
    <main className="page-z" data-testid="matchmaking-page">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 pt-10 pb-4">
        <Link
          to="/"
          data-testid="matchmaking-back-home"
          className="inline-flex items-center gap-2 text-xs tracking-widest text-[#a3a3ac] hover:text-[#14b8a6]"
        >
          <i className="fas fa-arrow-left" /> BACK TO LEAGUE HUB
        </Link>
      </div>
      <MatchmakingSection
        onToast={onToast}
        onRequireAuth={onRequireAuth}
        onOpenLeague={onOpenLeague}
      />
    </main>
  );
}

export default MatchmakingPage;
